export default {
  admin: "admin",
  maker: "maker",
};
